import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "M.75 12a11.25 11.25 0 1 0 22.5 0 11.25 11.25 0 1 0-22.5 0" }),
      createElementVNode("path", { d: "m5 20.8 1-5.05h1.08a1.48 1.48 0 0 0 1.18-.58 1.44 1.44 0 0 0 .27-1.28l-.75-3a1.49 1.49 0 0 0-1.45-1.14H1m20-4.5h-4.08a1.49 1.49 0 0 0-1.45 1.14l-.75 3a1.44 1.44 0 0 0 .28 1.28 1.48 1.48 0 0 0 1.18.58h1.58l.78 4.75A1.5 1.5 0 0 0 20 17.25h2" })
    ], -1)
  ]));
}
const travelMapEarthGlobe = { render };
export {
  travelMapEarthGlobe as default,
  render
};
//# sourceMappingURL=travel-map-earth-globe.svg.js.map
